// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TcsWrapperModelsClaimAccumulatorModel } from './tcsWrapperModelsClaimAccumulatorModel.js';
import type { TcsWrapperModelsClaimModel } from './tcsWrapperModelsClaimModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class TcsWrapperModelsTcsRedemptionListRecordModel {
    'offerType'?: string;
    'offerTypeDescription'?: string;
    'rollDate'?: string;
    'bin'?: string;
    'cardActivationDate'?: Moment;
    'cardEndDate'?: Moment;
    'sponsorNumber'?: string;
    'memberNumber'?: string;
    'groupNumber'?: string;
    'totalBenefitAmount'?: number;
    'remainingBenefitAmount'?: number;
    'totalPaidAmount'?: number;
    'accumulators'?: Array<TcsWrapperModelsClaimAccumulatorModel>;
    'redemptions'?: number;
    'memberNumberStatus'?: string;
    'memberNumberStatusId'?: string;
    'memberNumberType'?: string;
    'claims'?: Array<TcsWrapperModelsClaimModel>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TcsWrapperModelsTcsRedemptionListRecordModel>> = [
        {
            "name":     "offerType",
            "baseName": "offerType",
            "type":     "string"
        },
        {
            "name":     "offerTypeDescription",
            "baseName": "offerTypeDescription",
            "type":     "string"
        },
        {
            "name":     "rollDate",
            "baseName": "rollDate",
            "type":     "string"
        },
        {
            "name":     "bin",
            "baseName": "bin",
            "type":     "string"
        },
        {
            "name":     "cardActivationDate",
            "baseName": "cardActivationDate",
            "type":     "Date"
        },
        {
            "name":     "cardEndDate",
            "baseName": "cardEndDate",
            "type":     "Date"
        },
        {
            "name":     "sponsorNumber",
            "baseName": "sponsorNumber",
            "type":     "string"
        },
        {
            "name":     "memberNumber",
            "baseName": "memberNumber",
            "type":     "string"
        },
        {
            "name":     "groupNumber",
            "baseName": "groupNumber",
            "type":     "string"
        },
        {
            "name":     "totalBenefitAmount",
            "baseName": "totalBenefitAmount",
            "type":     "number"
        },
        {
            "name":     "remainingBenefitAmount",
            "baseName": "remainingBenefitAmount",
            "type":     "number"
        },
        {
            "name":     "totalPaidAmount",
            "baseName": "totalPaidAmount",
            "type":     "number"
        },
        {
            "name":     "accumulators",
            "baseName": "accumulators",
            "type":     "Array<TcsWrapperModelsClaimAccumulatorModel>"
        },
        {
            "name":     "redemptions",
            "baseName": "redemptions",
            "type":     "number"
        },
        {
            "name":     "memberNumberStatus",
            "baseName": "memberNumberStatus",
            "type":     "string"
        },
        {
            "name":     "memberNumberStatusId",
            "baseName": "memberNumberStatusId",
            "type":     "string"
        },
        {
            "name":     "memberNumberType",
            "baseName": "memberNumberType",
            "type":     "string"
        },
        {
            "name":     "claims",
            "baseName": "claims",
            "type":     "Array<TcsWrapperModelsClaimModel>"
        },
    ];

    static getAttributeTypeMap() {
        return TcsWrapperModelsTcsRedemptionListRecordModel.attributeTypeMap;
    }
}
